<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
							<div class="nav-bar box-horizontal mb-0">
								<i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
								<div class="flex-1">
									<h3 class="m-0">{{data.title}}</h3>
								</div>
							</div>
			              	<div class="card">
								<div class="card-body">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Nama Admin</label>
													<p class="form-control mb-0">{{data.nama}}</p>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Username</label>
													<p class="form-control mb-0">{{data.username}}</p>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-show="data.edit == 'tagih'">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Area</label>
													<div class="col-md-12">
														<ul class="list-group">
															<li class="list-group-item" v-for="(u, index) in data.areaListBy">
																<input type="checkbox" :value="u.id" v-model="data.checkedArea">
																{{u.nama}} 
															</li>
														</ul>
													</div>
												</div>
												<div class="form-group">
													<button class="btn btn-primary" @click="area.change()">Simpan</button>
												</div>
											</div>
										</div>
									</div>
									<div class="row" v-show="data.edit == 'voucher'">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Mikrotik</label>
													<select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Mikrotik..."  v-model="data.mikrotikPilih">
														<option value="" selected disabled>Pilih Mikrotik</option>
														<option v-for="(u, index) in data.mikrotik" :value="u.id" >{{u.nama}}</option>
													</select>
												</div>
											</div>
										</div>
										<div class="col-md-12">
                                        	<button class="btn btn-primary" @click="mikrotik.change()">Simpan Mikrotik</button>
										</div>
									</div>
								</div>
                          	</div>

			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Edit Password</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Password</label>
                                                <input type="password" class="form-control" placeholder="Password..." v-model="password.form.password">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Konfirmasi Password</label>
                                                <input type="password" class="form-control" placeholder="Password..." v-model="password.form.cpassword">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="password.change()">Simpan</button>
			                        </div>
                                    <div class="alert alert-warning" v-show="password.form.alert" role="alert">
                                        {{password.form.alertText}}
                                    </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import router from '@/router'

var numeral = require("numeral");

Vue.use(moment)

export default {
  	name: 'Beranda',
	components: { 

	}, 
    setup() {
		const data = reactive({
			params: {},
			nama: '',
			username: '',
			id: '',
			area: '',
			areaListBy: [],
			checkedArea: [],
			mikrotik: [],
			areaPilih: '',
			title: '',
			edit: null,
			mikrotikPilih: null,
			miaw: null
		})
        
		const area = {
			change() {
				data.areaPilih = "";
				for (let i = 0; i < data.checkedArea.length; i++) {
					if (data.areaPilih == "") {
						data.areaPilih = data.checkedArea[i];
					} else {
						data.areaPilih = data.areaPilih+","+data.checkedArea[i];
					}
					// data.checkedArea.push(x.data[i]['id']);
				} 

				// console.log(data.areaPilih);

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    area: data.areaPilih,
                    id: data.id
                };
                
                var apiUrl = inter.AdminAreaUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
                    //myGlobal.loger(x);
                    if (x.status) {
						router.push({ 
							name: 'admin-kangtagih'
						});
                    } else {
                        this.form.alert = true;
                        this.form.alertText = "Terjadi kesalahan";
                    }
				})
			},
			get() {
                var datax = new FormData();
                datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
                datax.append('type', "lunas");
                datax.append('bulan', "0");
                
                var apiUrl = inter.ListArea();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(data.area));

                    if (x.status) {
                        data.areaListBy = x.data;
						//data.checkedArea = data.area;
                    } else {
                    //alert(x.pesan);
                    }
				})
			},
			
			getBy() {
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken'),
					type: 'lunas',
					bulan: '0',
					by: data.area
				}
                
                var apiUrl = inter.ListAreaBy();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x.data));
                    if (x.status) {
                        //data.areaListBy = x.data;
						for (let i = 0; i < x.data.length; i++) {
							data.checkedArea.push(x.data[i]['id']);
						} 
                    } else {
                    	//alert(x.pesan);
                    }
				})
			}
		}

		const mikrotik = {
			list() {
				console.log("get Mikrotik");
				// for filter
				var datax = {
					token: 'TangTung '+sessionStorage.getItem('myToken')
				}
				
				var apiUrl = inter.MiktorikList();
				myGlobal.call(datax,apiUrl).then(x => {
					if (x.status) {
						console.log(JSON.stringify(x));
						data.mikrotik = x.data;
					} else {
						//alert(x.pesan);
					}
				})
			},
			change() {
                if (data.mikrotikPilih == null) {
					alert("Mikrotik tidak boleh kosong");
					return false;
                }

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    mikrotik: data.mikrotikPilih,
                    id: data.id
                };
                
                var apiUrl = inter.AdminMikrotikUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
                    //myGlobal.loger(x);
                    if (x.status) {
                        data.miaw.$router.go(-1)
                    } else {
						alert(x.data.pesan);
                    }
				})
			}
			
		}

        const password = {
            form: reactive({
                password: '',
                cpassword: '',
                alert: false,
                alertText: ''
            }),
			change() {
                if (this.form.password != this.form.cpassword) {
                    this.form.alert = true;
                    this.form.alertText = "Password tidak sama";
                    return false;
                }
                
                this.form.alert = false;

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    password: this.form.cpassword,
                    id: data.id
                };
                
                var apiUrl = inter.AdminUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
                    //myGlobal.loger(x);
                    if (x.status) {
						router.push({ 
							name: 'admin-kangtagih'
						});
                    } else {
                        this.form.alert = true;
                        this.form.alertText = "Terjadi kesalahan";
                    }
				})
			}

        }

        return {
			data,
            area,
            password,
			mikrotik
		}
	},
    mounted () {
		if (this.$route.params.kang == 'voucher' ) {
			this.data.title = "Edit Kang Voucher";
			this.data.edit = this.$route.params.kang;
		} else {
			this.data.title = "Edit Kang Tagih";
			this.data.edit = "tagih";
		}

		// kalo disini pake this
        this.data.id = this.$route.params.id;
		this.data.params = this.$route.params.data;
        
        this.data.nama = this.data.params.nama;
        this.data.username = this.data.params.pin;
        this.data.area = this.data.params.area;

		this.data.miaw = this;

        console.log(JSON.stringify(this.$route.params));

        this.area.get();
        this.area.getBy();

		this.mikrotik.list();
    }
}
/*
export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '',
			password: '',
			username: '',
			area: '',
			areaId: '',
			areaList: [],	
			modalArea: false,
		}
	},
	methods: {
		pilihArea(id,nama) {
			var areaInput = this.area;

			if (areaInput.indexOf(nama) === -1) {
				if (areaInput == "") {
					this.area = nama;
					this.areaId = id;
				} else {
					this.area = this.area + ", " + nama;
					this.areaId = this.areaId + "," + id;
				}
			}
		},
		getArea() {
			// for filter
			var data = new FormData();
			data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
			data.append('type', "lunas");
			data.append('bulan', "0");
			
      		var apiUrl = inter.ListArea(); // 'ListArea';
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.areaList = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
        Simpan() {
			//alert(this.areaId);
			//return false;

			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('nama', this.nama);
            data.append('area', this.areaId);
            data.append('password', this.password);
			data.append('username', this.username);
			
			
            var apiUrl = 'TambahAdmin';
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
					
					router.push({ 
						name: 'admin-kangtagih'
					});
					
				} else {
				    alert(x.pesan);
				}
			})
        }
	},
	mounted() {
		this.getArea();
	}
}
*/
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kangtagih/edit.vue